export const callbackTableColumns = [
  {

    title: "Product",
    dataIndex: "productFamily",
    key: "productFamily",
    width: "12%"
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    width: "12%"
  },
  {
    title: "Type",
    dataIndex: "callbackType",
    key: "callbackType",
    width: "10%"
  },
  {
    title: "Entitlement",
    dataIndex: "entitlement",
    key: "entitlement",
    width: "10%"
  },
  {
    title: "Priority",
    dataIndex: "PRIORITYTEXT",
    key: "PRIORITYTEXT",
    width: "10%"
  },
  {
    title: "Org Name",
    dataIndex: "ORGNAME",
    key: "ORGNAME",
    width: "10%"
  },
  {
    title: "Case Id",
    dataIndex: "caseId",
    key: "caseId",
    width: "10%"
  },
  {
    title: "Case Assigned TSE",
    dataIndex: "ASSIGNED_ENGINEER_FULLNAME",
    key: "ASSIGNED_ENGINEER_FULLNAME",
    width: "10%"
  },
  {
    title: "Callback Assigned TSE",
    dataIndex: "CALLBACK_REASSIGNED_TSE",
    key: "CALLBACK_REASSIGNED_TSE",
    width: "10%"
  },
  {
    title: "TSE Manager",
    dataIndex: "tseManagerName",
    key: "tseManagerName",
    width: "12%"
  },
  {
    title: "Status",
    dataIndex: "requestStatus",
    key: "requestStatus",
    width: "15%"
  },
  {
    title: "CRM Queue",
    dataIndex: "CRMQUEUE",
    key: "CRMQUEUE",
    width: "15%"
  },
  {
    title: "Contact Endpoint",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    width: "14%"
  },
  {
    title: "Customer Timezone",
    dataIndex: "timezone",
    key: "timezone",
    width: "12%"
  },
  {
    title: "Request Time",
    dataIndex: "callbackTimeEpoch",
    key: "callbackTimeEpoch",
    width: "12%"
  },
  {
    title:"Scheduled Time",
    dataIndex:"callbackScheduleTime",
    key:"callbackScheduleTime",
    width:"12%"
  },
  {
    title: "Accept Time",
    dataIndex: "acceptTimeEpoch",
    key: "acceptTimeEpoch",
    width: "12%"
  },
  {
    title: "Dial Time",
    dataIndex: "dialTimeEpoch",
    key: "dialTimeEpoch",
    width: "12%"
  },
  // {

  //   title: "Schedule Time",
  //   dataIndex: "callbackScheduleTimeEpoch",
  //   key: "callbackScheduleTimeEpoch",
  //    width: "15%"
  // },
  // {
  //   title: "Timezone",
  //   dataIndex: "timezone",
  //   key: "timezone",
  //   // width: "15%"
  // },
  // {
  //   title: "Notes",
  //   dataIndex: "notes",
  //   key: "notes",
  //   // width: "15%"
  // },
  
  {
    title: "Call Attempts By",
    dataIndex: "userLdap",
    key: "userLdap",
    width: "12%"
  },
  {
    title: "Call Attempts",
    dataIndex: "connectContacts",
    key: "connectContacts",
    width: "12%"
  },
  {
    title: "Contact ID",
    dataIndex: "contactId",
    key: "contactId",
    width: "20%"
  },
  {
    title: "Current Routing Status",
    dataIndex: "routingCurrentStatus",
    key: "routingCurrentStatus",
    width: "15%"
  },
  {
    title: "Callback Surface",
    dataIndex: "callbackSurface",
    key: "callbackSurface",
    width: "12%"
  },
  // {
  //     title: "Action",
  //     dataIndex: "actions",
  //     key: "actions",
  //     // width: "15%"

  // }
  {
    title: "Edit Callback",
    dataIndex: "editCallback",
    key: "editCallback",
    width: "20%"
  }
];

export const callbackStatus = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "New",
    id: "NEW",
  },
  {
    name: "In Progress",
    id: "INPROGRESS",
  },
  {
    name: "Completed",
    id: "COMPLETED",
  },
  {
    name: "Failed",
    id: "FAILED",
  },
  {
    name:"Cancelled",
    id:"CANCELLED"
  }
];

  // Define color map once, outside the function
  export const STATUS_COLORS: Record<string, string> = {
    PENDING: "#FFA500",
    IN_PROGRESS: "#F68511",
    INPROGRESS: "#F68511",
    COMPLETED: "#008000", 
    FAILED: "#DB232D",
    NEW: "#147AF3",
    CANCELLED: "#808080",
    ALL: "",
  };
export const callbackTypes = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "Immediate",
    id: "IMMEDIATE",
  },
  {
    name: "Scheduled",
    id: "SCHEDULED",
  },
  {
    name: "Scheduled Web",
    id: "SCHEDULED_WEB",
  },
];

export const callbackSurface = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "EXL-Case Detail",
    id: "EXL-Case Detail",
  },
  {
    name: "EXL-Home",
    id: "EXL-Home",
  },
];

export const priority = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "P1 - Critical",
    id: "P1 - Critical",
  },
  {
    name: "P2 - Urgent",
    id: "P2 - Urgent",
  },
  {
    name: "P3 - Important",
    id: "P3 - Important",
  },
];

export const entitlement = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "Expert",
    id: "Expert",
  },
  {
    name: "Ultimate",
    id: "Ultimate",
  },
];

export const managerNames = [
  {
    name: "All",
    id: "ALL",
  },
];